import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RootState } from '../../../store';
import { useSelector } from 'react-redux';

export interface NotFoundProps { }


type Props = NotFoundProps & RouteComponentProps


const NotFound: React.FunctionComponent<Props> = props => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const goHome = () => {
        props.history.push({ pathname: `/${currentAoo?.id}/ricerca` });
    }

    return (
        <div className="error-page">
            <div className="error-code-container">
                <FontAwesomeIcon className="error-icon" icon={{ prefix: 'fas', iconName: 'telescope' }} />
                <h1 className="error-code">404</h1>
            </div>
            <h2 className="error-description">Pagina non trovata</h2>
            <a onClick={goHome} className="error-page-button">Home</a>
        </div >
    );

}
export default withRouter(NotFound);